<template>
  <v-form @input="$emit('valid', $event)">
    <v-select
      filled
      dense
      :items="reasons"
      label="Please let us know why you are canceling your subscription"
      :rules="[rules.required('A cancel reason')]"
      v-model="selectedReason"
      :persistent-hint="!selectedReason"
      :hint="!selectedReason ? 'Choose one reason' : ''"
    ></v-select>
    <v-textarea
      v-if="selectedReason === 'OTHER'"
      filled
      dense
      label="Please let us know why you are canceling your subscription"
      v-model="selectedReasonDetails"
      :rules="[rules.required('Details')]"
    ></v-textarea>
  </v-form>
</template>

<script>
import * as rules from "@/services/rules";

export default {
  name: "CancelReasonForm",
  data() {
    const returnData = {
      rules,
      selectedReason: null,
      selectedReasonDetails: null
    };
    //#region These need to match StandardizedSubscriptionCancellationReason.java
    returnData["reasons"] = [
      {
        text: "I do not want my subscription to automatically renew",
        value: "CVC_CANCEL"
      },
      {
        text: "I no longer work with any clients that use VendorProof",
        value: "CVC_NO_LONGER_WORK_WITH"
      },
      {
        text: "My company is going out of business",
        value: "GOING_OUT_OF_BUSINESS"
      },
      { text: "Other", value: "OTHER" }
    ];
    //#endregion
    return returnData;
  },
  methods: {
    emitInput() {
      this.$emit("input", {
        selectedReason: this.selectedReason,
        selectedReasonDetails: this.selectedReasonDetails
      });
    }
  },
  watch: {
    selectedReason() {
      this.emitInput();
    },
    selectedReasonDetails() {
      this.emitInput();
    }
  }
};
</script>
